import Markdown, { defaultUrlTransform } from 'react-markdown';

export function improvementLink(url: string) {
  const safe = defaultUrlTransform(url);
  if (!safe) return '';
  try {
    return ['http:', 'https:', 'mailto:'].includes(new URL(safe, 'https://investorhub.invalid').protocol) ? safe : '';
  } catch { return ''; }
}
export function ImprovementMarkdown({ children }: { children: string }) {
  return <div className="improvement-markdown"><Markdown skipHtml urlTransform={improvementLink}
    allowedElements={['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'strong', 'em', 'a', 'blockquote', 'code', 'pre', 'hr', 'br']}
    components={{
      h1: ({ children }) => <h3>{children}</h3>, h2: ({ children }) => <h3>{children}</h3>,
      a: ({ href, children }) => href ? <a href={href} target="_blank" rel="noopener noreferrer">{children}</a> : <span>{children}</span>,
    }}>{children || 'No description yet.'}</Markdown></div>;
}
